<template>
  <div class="c-media-header">
    <h4 class="c-media-header-count">{{ $t('media.count', { count: mediaFiles.length }) }}</h4>
    <CBulletBetween>
      <span v-if="images.length > 0">{{ $t('media.imageCount', { count: images.length }) }}</span>
      <span v-if="videos.length > 0">{{ $t('media.videoCount', { count: videos.length }) }}</span>
      <span v-if="audios.length > 0">{{ $t('media.audioCount', { count: audios.length }) }}</span>
      <span v-if="documents.length > 0">{{ $t('media.documentCount', { count: documents.length }) }}</span>
    </CBulletBetween>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import MediaFile from '@/general/models/MediaFile';
  import MediaFile2 from '@/general/models/MediaFile2';
  import CBulletBetween from '@/shared/components/base/CBulletBetween.vue';
  import MediaFileType from '@/shared/constants/MediaFileType';

  const props = defineProps<{
    mediaFiles: Array<MediaFile | MediaFile2>;
  }>();

  const images = computed(() => props.mediaFiles.filter(mediaFile => mediaFile.type === MediaFileType.IMAGE));
  const videos = computed(() => props.mediaFiles.filter(mediaFile => mediaFile.type === MediaFileType.VIDEO));
  const audios = computed(() => props.mediaFiles.filter(mediaFile => mediaFile.type === MediaFileType.AUDIO));
  const documents = computed(() => props.mediaFiles.filter(mediaFile => mediaFile.type === MediaFileType.PDF));
</script>

<style lang="scss">
  .c-media-header {
    &-count {
      font-size: 1.25rem;
      margin-bottom: .25rem;
    }
  }
</style>